/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TGetConstructorsListRequest,
  TGetConstructorsListModel,
  IMappers,
  TGetConstructorsListResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetV3ConstructorsListResponse } from '../../entities/v3_entities/GetV3ConstructorsListResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetConstructorsListModel(parameters: TGetConstructorsListRequest): TGetConstructorsListModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'countryside-constructors',
    pathApi: '/v3/get-constructors-list/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetConstructorsListOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetConstructorsListRequest;
}

export async function fetchGetConstructorsList<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetConstructorsListOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetConstructorsListResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetConstructorsListModel(parameters),
    config,
  )) as FetchResponse<TGetConstructorsListResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetV3ConstructorsListResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetConstructorsListResponse>;
}
